import React, {
  memo,
  useState,
  useContext,
  useEffect,
  useRef,
  useMemo,
} from "react";
import { Box } from "@mui/material";
import Tabla from "./Componentes/Tabla";
import ModalB from "./Componentes/ModalB";

import AuthContext from "../../../Context/Auth/AuthContext";
import AlertaContext from "../../../Context/Alerta/AlertaContext";
import clienteAxios from "../../../config/axios";
import BarraTablas from "../../../components/BarraTablas/BarraTablas";
import io from "socket.io-client";
import { socketUrl } from "../../../config/const";
import { usePermiso } from "../../../hooks/usePermiso";
import Modal from "./Componentes/Modal";
import ModalBConHorarios from "../../Configuración/Abastecimientos/Componentes/ModalBConHorarios";
const CuentasXCobrar = (props) => {
  const { tienePermiso } = usePermiso("CuentasXCobrar");
  const {
    documento,
    settab,
    setarrayExportHijos,
    desdeOtroLugarPersona,
    // itemRelacionadoPadre,
    desdeOtroLugarVenta,
  } = props;
  // DATA DEL STATE

  const [rows, setrows] = useState(null);

  const [ObjectoActivo, setObjetoActivo] = useState({
    ccComprobante: "",
    ccEstado: "",
    ventaId: "",
    ccRucCliente: "",
    ccNomCliente: "",
    ccFactura: "",
    ccFechaFactura: "",
    ccValorFactura: "",
    ccValorRetencion: "",
    ccValorAPagar: "",
    ccFechaAbono: "",
    ccProcedencia: "",
    ccAbono: "",
    ccSaldo: "",
    ccEmpresa: "NE2021",
    ccUser: "admin",
    ccPagos: [
      // {
      //   ccTipo: "EFECTIVO",
      //   ccBanco: "Banco Del Guayaquil",
      //   ccNumero: "24",
      //   ccDeposito: "NO",
      //   ccValor: "5",
      //   ccFechaAbono: "2022-01-07",
      //   ccDetalle: "",
      //   ccProcedencia: "",
      //   ccEstado: "ACTIVO",
      // },
    ],
    ccFecReg: "",
    Todos: "",
  });

  const [pagination, setpagination] = useState(null);
  // FUNCIONES STATE
  const getDataState = async (
    cantidad,
    page,
    search,
    input,
    orden,
    datos,
    rucempresa
  ) => {
    console.log({ datos: JSON.parse(datos) });

    let datosObj = JSON.parse(datos);

    if (datosObj.horarios && datosObj.horarios.includes(" - ")) {
      const [fechaHora1, fechaHora2] = datosObj.horarios.split(" - ");
      datosObj.ccFecReg1 = fechaHora1;
      datosObj.ccFecReg2 = fechaHora2;
    }

    // Ahora puedes usar datosObj en lugar de JSON.parse(datos)
    console.log({ datosObj });
    const res = await clienteAxios.get(
      `/cuentasporcobrar/?cantidad=${cantidad}&page=${page}&search=${
        search ? search : ""
      }&input=${input ? input : ""}&orden=${orden ? orden : ""}&datos=${
        datos ? JSON.stringify(datosObj) : ""
      }&rucempresa=${rucempresa ? rucempresa : ""}&documento=${
        documento ? documento : ""
      }&allData=${tienePermiso("allData")}`
    );
    console.log({ res });

    return res;
  };

  const obtenerState = async (
    cantidad = 10,
    page = 0,
    search,
    input,
    orden,
    datos,
    rucempresa
  ) => {
    const res = await getDataState(
      cantidad,
      page,
      search,
      input,
      orden,
      datos,
      rucempresa
    );
    setrows(res.data.data.results);
    setpagination(res.data.data.pagination);
  };
  const addRowsState = async (items) => {
    setrows([...rows, ...items]);
  };
  const remplazarRowsState = async (
    cantidad,
    page,
    search,
    input,
    orden,
    datos,
    rucempresa
  ) => {
    const res = await getDataState(
      cantidad,
      page,
      search,
      input,
      orden,
      datos,
      rucempresa
    );
    setrows(res.data.data.results);
    setpagination(res.data.data.pagination);
    // dispatch({
    //   type: OBTENER,
    //   payload: {
    //     results: res.data.data.results,
    //     pagination: res.data.data.pagination,
    //   },
    // });
  };
  const agregarState = async (item) => {
    try {
      setrows([item, ...rows]);

      setpagination({
        ...pagination,
        numRows: pagination.numRows + 1,
      });
    } catch (error) {}
  };

  const editarState = async (item) => {
    try {
      const resRows = rows.map((itemR) => {
        if (itemR.ccId === item.ccId) {
          return item;
        } else {
          return itemR;
        }
      });

      setrows(resRows);
    } catch (error) {}
  };

  const eliminarState = async (_id) => {
    try {
      const resRows = rows.filter((row) => {
        return row.ccId !== _id;
      });
      setrows(resRows);
      setpagination({
        ...pagination,
        numRows: pagination.numRows - 1,
      });
    } catch (error) {}
  };
  const eliminarSeleccionState = async (_ids) => {
    const resRows = rows.filter((row) => {
      return !_ids.some((item) => {
        return item === row.ccId;
      });
    });
    setpagination({
      ...pagination,
      numRows: pagination.numRows - _ids.length,
    });
    setrows(resRows);
  };

  const changeObjetoActivoState = (item) => {
    setObjetoActivo(item);
    // dispatch({
    //   type: CHANGE_ACTIVO,
    //   payload: item,
    // });
  };

  const rowsImportState = (rows) => {
    // dispatch({
    //   type: IMPORTAR_ROWS,
    //   payload: rows,
    // });
    setrows(rows);
  };
  // FIN FUNCIONES STATE
  // FIN DATA STATE

  // FUNCIONES SOCKET
  const [tabla] = useState("cuentasporcobrar");
  const [itemSocket, setitemSocket] = useState({
    tipo: "",
    item: {},
  });

  const socket = useRef();
  useEffect(() => {
    // Creates a WebSocket connection
    socket.current = io(socketUrl);
    socket.current.on("server:guardadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }

      setitemSocket({
        tipo: "agregar",
        item: data,
      });
    });
    socket.current.on("server:actualizadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      console.log({ data });

      setitemSocket({
        tipo: "editar",
        item: data,
      });
    });
    socket.current.on("server:eliminadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      setitemSocket({
        tipo: "eliminar",
        item: data,
      });
    });
    socket.current.on("server:eliminadoExitosoSeleccionado", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      setitemSocket({
        tipo: "eliminarSeleccion",
        item: data,
      });
    });

    socket.current.on("server:error", (data) => {
      mostrarAlerta(
        data.msg ? data.msg : "Hubo un error",
        data.alert ? data.alert : "error"
      );
    });
    return () => {
      socket.current.disconnect();
    };
    // Destroys the socket reference
    // when the connection is closed
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    const { item, tipo } = itemSocket;

    if (tipo === "") {
      return;
    }
    if (!rows) {
      return;
    }
    if (usuario.rucempresa !== item.rucempresa) {
      return;
    }

    if (
      (desdeOtroLugarPersona || desdeOtroLugarVenta) &&
      item.ccRucCliente !== documento
    ) {
      return;
    }
    const funcionAalerta = () => {
      if (item.msg === "") {
        return null;
      }
      if (!item.msg) {
        return null;
      }
      mostrarAlerta(item.msg, item.alert ? item.alert : "success");
    };

    if (tipo === "agregar") {
      agregarState(item);
    }
    if (tipo === "editar") {
      editarState(item);
    }
    if (tipo === "eliminar") {
      eliminarState(item.ccId);
    }
    if (tipo === "eliminarSeleccion") {
      eliminarSeleccionState(item.lista);
    }
    funcionAalerta();
    setitemSocket({ tipo: "", item: {} });
    // eslint-disable-next-line
  }, [itemSocket]);
  //LO QUE YA ESTABA
  const { mostrarAlerta } = useContext(AlertaContext);
  const {
    usuario: { rucempresa },
    usuario,
  } = useContext(AuthContext);
  const [buscando, setbuscando] = useState(false);
  const [search, setsearch] = useState("");
  const [cargando, setcargando] = useState(false);
  const [agregar, setagregar] = useState(false);
  const [open, setOpen] = useState(false);
  const [input, setinput] = useState({
    id: "ccId",
    label: "ID",
    minWidth: 150,
    tipo: "string",

    propiedad: "ccId",
  });
  const [arrayExport, setarrayExport] = useState([]);
  const [campoExport] = useState("ccId");
  useEffect(() => {
    if (desdeOtroLugarPersona || desdeOtroLugarVenta) {
      settab("");
      setarrayExportHijos(arrayExport.map((item) => item[campoExport]));
    }
    // eslint-disable-next-line
  }, [arrayExport]);

  const [orden, setorden] = useState(false);
  const [openMB, setopenMB] = useState(false);

  const arrayProps = [
    {
      label: "Factura",
      propiedad: "ccFactura",
      tipo: "string",
      orden: 1,
    },
    {
      id: "ccProcedencia",
      label: "Procedencia",
      minWidth: 50,
      tipo: "string",
      variante: "autocompleteComun",
      data: ["FACTURA", "NOTA VENTA"],
      propiedad: "ccProcedencia",
    },

    {
      id: "ccEstado",
      label: "Estado",
      minWidth: 50,
      tipo: "string",
      variante: "autocompleteComun",
      data: ["PENDIENTE", "CANCELADO", "ANULADA"],
      propiedad: "ccEstado",
    },
    {
      label: "Fecha Fac.",
      propiedad: "ccFechaFactura",
      tipo: "fecha",
      orden: 4,
    },
    {
      label: "Fec. Reg",
      propiedad: "ccFecReg",
      tipo: "fecha",
      orden: 5,
    },
    {
      id: "usuario",
      label: "Usuario",
      minWidth: 100,
      tipo: "string",
      propiedad: "usuario",
      variante: "autocompleteDataDefault",
      propiedadesMostrar: 2,
      campoData1: "perDocNumero",
      campoData2: "perNombre",

      getData: async () => {
        const resusuariosData = await clienteAxios.get(
          `proveedores/listar/por/perfil?perfil=USUARIO`
        );
        console.log({ resusuariosData });

        // setusuariosData(setitemsPersonas(resusuariosData.data));
        return { data: resusuariosData };
      },
    },
  ];
  const defaultFullBuscador = () => {
    const json = {};
    arrayProps.forEach((itemPropiedad) => {
      Object.entries({ itemPropiedad }).forEach((item) => {
        if (itemPropiedad.tipo === "string") {
          json[`${item[1].propiedad}`] = "";
        } else {
          json[`${item[1].propiedad}1`] = "";
          json[`${item[1].propiedad}2`] = "";
        }
      });
    });
    console.log({ json, arrayProps });

    return json;
  };
  const [fullBuscador, setfullBuscador] = useState(defaultFullBuscador());

  //pagina actual
  const [page, setPage] = React.useState(0);
  //filas por pagina
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  // input
  //
  const handleChange = (e) => {
    setfullBuscador({ ...fullBuscador, [e.target.name]: e.target.value });
  };
  const funcionB = async () => {
    setcargando(true);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa
    );
    setPage(0);
    setbuscando(true);
    setopenMB(false);
    setcargando(false);
  };

  const handleSearch = async () => {
    setcargando(true);
    setPage(0);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa
    );
    setcargando(false);
  };
  useEffect(() => {
    const fullBRes = defaultFullBuscador();
    setfullBuscador(fullBRes);
    // eslint-disable-next-line
  }, []);

  const funcionDefault = async () => {
    setcargando(true);
    const fullBRes = defaultFullBuscador();
    setfullBuscador(fullBRes);
    await remplazarRowsState(
      rowsPerPage,
      0,
      "",
      input.id,
      orden,
      JSON.stringify(fullBRes),
      rucempresa
    );
    setarrayExport([]);
    setPage(0);
    setsearch("");
    setbuscando(false);
    setcargando(false);
    setopenMB(false);
  };

  const columns = useMemo(
    () => [
      {
        id: "ccRucCliente",
        label: "Ruc Proveedor",
        minWidth: 75,
        tipo: "string",

        propiedad: "ccRucCliente",
      },
      {
        id: "ccOtrosDetalles",
        label: "Placa",
        minWidth: 75,
        tipo: "string",

        propiedad: "ccOtrosDetalles",
      },

      {
        id: "ccFactura",
        label: "Factura",
        minWidth: 75,
        tipo: "string",

        propiedad: "ccFactura",
      },

      {
        id: "ccFechaFactura",
        label: "Fecha",
        minWidth: 75,
        tipo: "string",

        propiedad: "ccFechaFactura",
      },
      {
        id: "ccProcedencia",
        label: "Procedencia",
        minWidth: 50,
        tipo: "string",

        propiedad: "ccProcedencia",
      },
      {
        id: "ccEstado",
        label: "Estado",
        minWidth: 50,
        tipo: "string",

        propiedad: "ccEstado",
      },
     
      {
        id: "ccValorFactura",
        label: "V.Fact.",
        minWidth: 50,
        tipo: "string",

        propiedad: "ccValorFactura",
      },

      {
        id: "ccValorAPagar",
        label: "V.Pagar",
        minWidth: 50,
        tipo: "string",

        propiedad: "ccValorAPagar",
      },

      {
        id: "ccAbono",
        label: "Abono",
        minWidth: 50,
        tipo: "string",

        propiedad: "ccAbono",
      },
      {
        id: "ccSaldo",
        label: "Saldo",
        minWidth: 75,
        tipo: "string",

        propiedad: "ccSaldo",
      },
      {
        id: "ccFecReg",
        label: "Fec Reg.",
        minWidth: 75,
        tipo: "string",

        propiedad: "ccFecReg",
      },
      {
        id: "ccUser",
        label: "User",
        minWidth: 150,
        tipo: "string",

        propiedad: "ccUser",
      },
    ],
    [usuario.empCategoria]
  );
  const [horarios, sethorarios] = useState([]);
  const [bancos, setbancos] = useState(null);
  useEffect(() => {
    if (bancos === null) {
      const getDataState = async () => {
        const res = await clienteAxios.get("/bancos/filtro/0");
        console.log({ res });

        setbancos(res.data.data);
      };
      getDataState();
    } // eslint-disable-next-line
  }, []);

  if (!fullBuscador) {
    return null;
  }

  return (
    <Box>
      <Modal
        open={open}
        setopen={setOpen}
        socket={socket}
        arrayExport={arrayExport}
        campoExport={campoExport}
        columns={columns}
        bancos={bancos}
        funcionDefault={funcionDefault}
        setcargando={setcargando}
        cargando={cargando}
      />
      <BarraTablas
        setopen={setOpen}
        disabled={
          arrayExport.filter((item) => item.ccEstado === "PENDIENTE").length ===
          0
        }
        search={search}
        setsearch={setsearch}
        funcion={handleSearch}
        buscando={buscando}
        setbuscando={setbuscando}
        setopenMB={setopenMB}
        LabelBuscador={
          "Buscar Por: Proveedor, Factura, Fecha, Procedencia, Estado"
        }
        ocultarBuscar={false}
        funcionDefault={funcionDefault}
        ocultarMigasDePan={desdeOtroLugarPersona || desdeOtroLugarVenta}
        labelAgregar="MULTIPAGOS"
      />
      {/* <ModalB
        defaultFullBuscador={defaultFullBuscador}
        openMB={openMB}
        setopenMB={setopenMB}
        titulo={"Busqueda avanzada (Cuentas Por Cobrar)"}
        fullBuscador={fullBuscador}
        setfullBuscador={setfullBuscador}
        arrayProps={arrayProps}
        handleChange={handleChange}
        funcionB={funcionB}
        buscando={buscando}
        funcionDefault={funcionDefault}
      /> */}
      <ModalBConHorarios
        defaultFullBuscador={defaultFullBuscador}
        openMB={openMB}
        setopenMB={setopenMB}
        titulo={"Busqueda avanzada (Cuentas Por Cobrar)"}
        fullBuscador={fullBuscador}
        setfullBuscador={setfullBuscador}
        sethorarios={sethorarios}
        horarios={horarios}
        arrayProps={[
          ...arrayProps,
          {
            id: "horarios",
            label: "Horario",
            minWidth: 50,
            tipo: "string",
            variante: "autocompleteComun",
            data: horarios,
            propiedad: "horarios",
          },
        ]}
        handleChange={handleChange}
        funcionB={funcionB}
        buscando={buscando}
        funcionDefault={funcionDefault}
      />
      <Tabla
        agregar={agregar}
        setagregar={setagregar}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        rows={rows}
        search={search}
        input={input}
        orden={orden}
        setinput={setinput}
        setorden={setorden}
        cargando={cargando}
        setcargando={setcargando}
        fullBuscador={fullBuscador}
        // STATE
        addRowsState={addRowsState}
        getDataState={getDataState}
        remplazarRowsState={remplazarRowsState}
        obtenerState={obtenerState}
        pagination={pagination}
        columns={columns}
        ObjectoActivo={ObjectoActivo}
        changeObjetoActivoState={changeObjetoActivoState}
        rowsImportState={rowsImportState}
        socket={socket}
        // export
        arrayExport={arrayExport}
        setarrayExport={setarrayExport}
        campoExport={campoExport}
        bancos={bancos}
      />
    </Box>
  );
};

export default memo(CuentasXCobrar);
